import { ChangeDetectionStrategy, Component, inject, input, viewChild } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MainTabsService } from './main-tabs-service';
import { RouterResolveStatusService } from '@app/modules/shared/services/router-resolve-status.service';
import { Router, RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';
import { ConnectionService } from '@shared/services/connection.service';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { MatIcon } from '@angular/material/icon';
import { MatProgressBar } from '@angular/material/progress-bar';
import { ParseQueryParamsPipe } from '../../../shared/pipes/parse-query-params.pipe';

@Component({
  selector: 'app-main-tabs',
  templateUrl: './main-tabs.component.html',
  styleUrl: './main-tabs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatTabNav,
    MatTabLink,
    RouterLinkActive,
    RouterLink,
    MatIcon,
    MatMenuTrigger,
    MatTabNavPanel,
    MatProgressBar,
    RouterOutlet,
    MatMenu,
    MatMenuItem,
    ParseQueryParamsPipe,
  ],
})
export class MainTabsComponent {
  mainTabsService = inject(MainTabsService);
  routerResolveStatus = inject(RouterResolveStatusService);
  connectionService = inject(ConnectionService);
  private router = inject(Router);

  readonly contextMenuTrigger = viewChild(MatMenuTrigger);
  readonly parentComponentId = input<string>(undefined);

  readonly tabs = toSignal(this.mainTabsService.activeTabs$, { requireSync: true });
  // Temporary way to store index of right clicked tab for context menu
  public indexOfTab: number;
  // Store the position where the menu should open
  public menuPosition = { x: 0, y: 0 };
  private componentPosition = { x: 260, y: 70 }; // 260 is sidenav width, 70 is top toolbar height
  private componentId = this.generateComponentId();

  /** Reactive unread-message count for a tab, derived from its link (0 for non-conversation tabs). */
  unreadCount(link: string): number {
    return this.mainTabsService.unreadCountForLink(link);
  }

  /** Badge text, capped at "9+" for ten or more unread messages. */
  badgeLabel(count: number): string {
    return count >= 10 ? '9+' : count.toString();
  }

  onContextMenu(event: MouseEvent, index: number) {
    event.preventDefault();

    this.menuPosition.x = event.clientX - this.componentPosition.x;
    this.menuPosition.y = event.clientY - this.componentPosition.y;

    this.indexOfTab = index;
    this.contextMenuTrigger().openMenu();
  }

  private generateComponentId(): string {
    return Math.random().toString(36).substring(2, 15);
  }
}
